import { BombModuleType } from "./internal-types";
import * as modules from '../modules';

export default function getModuleName(id: BombModuleType) {
  return modules[id].name;
}
